export const SET_IS_SIGNUP = "SET_IS_SIGNUP"